import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../QueryKeys'
import { tasksService } from '../../tasksService'
import { TaskTemplateFormPayload } from '../../types'

export const useUpdateTaskTemplate = () => {
    const qc = useQueryClient()

    return useMutation({
        mutationFn: (data: TaskTemplateFormPayload) =>
            tasksService.updateTaskTemplate(data.id!, data),

        onSuccess: (_res, vars) =>
            Promise.all([
                qc.invalidateQueries({ queryKey: [QUERY_KEYS.tasks.templates.TASK_TEMPLATES] }),
                qc.invalidateQueries({
                    queryKey: [QUERY_KEYS.tasks.templates.TASK_TEMPLATES_ASSIGNEES],
                }),
                qc.invalidateQueries({
                    queryKey: [QUERY_KEYS.tasks.templates.TASK_TEMPLATES_DETAILS, vars.id],
                }),
            ]),
    })
}
